// subheadings.js

// JSON data for easy editing
var subheadingsData = {
  "shoutouts": [
    "Hi Bunny Den!",
    "Hi Club Light!",
    "Hi Twitter!",
    "Hi UdonVR!",
    "Hi Rhythm!",
    "Hi Janna's Wind Fortress!",
    "Hi Twilight Zone!",
    "Hi Gaybies!",
    "Hi XoxO!",
    "Hi Safari Zone!"
  ],
  "cursed": [
    "WAKE UP WAKE UP WAKE UP WAKE UP WAKE UP",
    "Charge Your Skin. Under Your Skin.",
    "HELP!!",
    "...",
    "ERP Ready.",
    "Buy For Your Snuggle Buddy.",
    "Lovense Integration Not Included.",
    "Can Anyone Read This? Hello?",
    "🫠"
  ],
  "subheadings": [
    "Jelly? Pucks? It's All Here!",
    "Small Batteries, Big Dreams.",
    "The Future Is Bright (And Charged).",
    "Powered by Gremlins. Maybe.",
    "Charging Trackers Since Like, Yesterday.",
    "For When USB Ports Betray You.",
    "Making Trackers Juicy Again.",
    "Who Needs Wires Anyway?",
    "Charging Stuff, Probably.",
    "Omg haiii :)",
    "Trackers Don’t Sleep, Why Should You?",
    "Batteries Are Temporary, Jelly Is Forever.",
    "Charge Up and Question Everything.",
    "Your Trackers Are Watching.",
    "Low Battery Isn’t the Only Thing to Fear.",
    "Your Trackers Know What You Did.",
    "The Last Thing Your Trackers Will Need.",
    "VR Devices & Accesories."
  ]
};

// Helper function to get a random element from an array
function getRandom(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

// Combine static subheadings with one random shoutout and one random cursed message
var combinedSubheadings = subheadingsData.subheadings.slice(); // copy the array
combinedSubheadings.push(getRandom(subheadingsData.shoutouts));
combinedSubheadings.push(getRandom(subheadingsData.cursed));

// Choose a random subheading from the combined list
var randomSubheading = getRandom(combinedSubheadings);

// Optionally, attach it to the window object for global access
window.randomSubheading = randomSubheading;
